import { db, ref, update, get, child, push } from "../database/config";

export function startAddingUser(user) {
  const newUserKey = user.id;
  const updates = {};
  updates["/users/" + newUserKey] = user;
  return (dispatch) => {
    return update(ref(db), updates)
      .then(() => {
        dispatch(addUser(user));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

export function startLoadingUser() {
  return (dispatch) => {
    return get(child(ref(db), "users"))
      .then((snapshot) => {
        let users = [];
        if (snapshot.exists()) {
          snapshot.forEach((childSnapshot) => {
            users.push(childSnapshot.val());
          });
          dispatch(loadUser(users));
        } else {
          console.log("No data available");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
}

export function startLoadingTasks() {
  return (dispatch) => {
    return get(child(ref(db), "tasks"))
      .then((snapshot) => {
        let tasks = {};
        if (snapshot.exists()) {
          snapshot.forEach((childSnapshot) => {
            // tasks[childSnapshot.key] = Object.values(childSnapshot.val());

            tasks[childSnapshot.key] = {
              key: Object.keys(childSnapshot.val()),
              value: Object.values(childSnapshot.val()),
            };
          });
          // console.log(tasksArray);
          dispatch(loadTask(tasks));
        } else {
          console.log("No data available");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
}

export function loadTask(tasks) {
  return {
    type: "LOAD_TASKS",
    tasks,
  };
}

export function startRemovingUser(index, id) {
  const newUserKey = id;
  const updates = {
    ["users/" + newUserKey]: null,
    ["tasks/" + newUserKey]: null,
  };
  return (dispatch) => {
    return update(ref(db), updates)
      .then(() => {
        dispatch(removeUser(index));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}
//remove
export function removeUser(index) {
  return {
    type: "REMOVE_USER",
    index: index,
  };
}
//add  user
export function addUser(user) {
  return {
    type: "ADD_USER",
    user,
  };
}

export function startAddingTask(
  taskName,
  taskStatus,
  assignedBy,
  createdAt,
  userid
) {
  const taskListRef = ref(db, "tasks/" + userid);
  const newTaskRef = push(taskListRef).key;
  const updates = {};
  updates[newTaskRef] = { taskName, taskStatus, assignedBy, createdAt };

  return (dispatch) => {
    return update(taskListRef, updates)
      .then(() => {
        dispatch(
          addTask(
            taskName,
            taskStatus,
            assignedBy,
            createdAt,
            userid,
            newTaskRef
          )
        );
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

export function addTask(
  taskName,
  taskStatus,
  assignedBy,
  createdAt,
  userid,
  taskid
) {
  return {
    type: "ADD_TASK",
    taskName,
    taskStatus,
    assignedBy,
    createdAt,
    userid,
    taskid,
  };
}

export function loadUser(users) {
  return {
    type: "LOAD_USERS",
    users,
  };
}

export function startRemovingTask(userid, taskid) {
  const updates = {
    ["tasks/" + userid + "/" + taskid]: null,
  };
  return (dispatch) => {
    return update(ref(db), updates)
      .then(() => {
        dispatch(removeTask(userid, taskid));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

export function removeTask(userid, taskid) {
  return {
    type: "REMOVE_TASK",
    userid,
    taskid,
  };
}

export function startClosingTask(userid, taskid) {
  console.log("in closing task");
  const updates = {
    ["tasks/" + userid + "/" + taskid + "/taskStatus"]: "Closed",
  };
  return (dispatch) => {
    return update(ref(db), updates)
      .then(() => {
        console.log("in closing task");
        dispatch(closeTask(userid, taskid));
      })
      .catch((e) => {
        console.log(e);
      });
  };
}

export function closeTask(userid, taskid) {
  return {
    type: "CLSOE_TASK",
    userid,
    taskid,
  };
}

// Set Task Name Filter
export function setTaskFilter(taskName) {
  return {
    type: "SET_NAME_FILTER",
    taskName,
  };
}

// Set Task Status Filter
export function setStatusFilter(taskStatus = "open") {
  return {
    type: "SET_STATUS_FILTER",
    taskStatus,
  };
}

// Get uth status
export function setAuthStatus({ authenticated, email }) {
  return {
    type: "SET_AUTH_STATUS",
    authenticated,
    email,
  };
}
